import { FormDamage } from '../types'

function assertUnreachable(x: never): never {
  throw new Error(`Didn't expect to get here: ${x}`)
}

const translateDamageKey = (key: keyof FormDamage, valueOrSubKey: string) => {
  switch (key) {
    case 'bumperFront':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.bumperFront'
    case 'bumperBack':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.bumperBack'
    case 'fenderLeft':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.fenderLeft'
    case 'fenderRight':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.fenderRight'
    case 'engineCooler':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.engineCooler'
    case 'engineHood':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.engineHood'
    case 'frontDoorLeft':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.frontDoorLeft'
    case 'frontDoorRight':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.frontDoorRight'
    case 'sidePanelOrDoorLeft':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.sidePanelOrDoorLeft'
    case 'sidePanelOrDoorRight':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.sidePanelOrDoorRight'
    case 'tailgate':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.tailgate'
    case 'tires':
      switch (valueOrSubKey) {
        case 'frontLeft':
          return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.tiresFrontLeft'
        case 'frontRight':
          return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.tiresFrontRight'
        case 'rearLeft':
          return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.tiresBackLeft'
        case 'rearRight':
          return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.tiresBackRight'
      }
      break
    case 'hadWindow':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.hadWindow'
    case 'window':
      return valueOrSubKey
    case 'hadOther':
      return 'pages.damageReports.damageReportForm.summaryFields.damageDescription.hadOther'
    case 'other':
      return valueOrSubKey
    default:
      return assertUnreachable(key)
  }
}

export const damageDescription = (
  damage: FormDamage,
  languageTranslator: Function
) => {
  const damages = Object.keys(damage) as (keyof FormDamage)[]

  const damageList = damages.flatMap((key) => {
    if (key === 'tires') {
      const tireDamages = Object.keys(
        damage['tires']
      ) as (keyof FormDamage['tires'])[]

      return tireDamages.flatMap((tireKey) =>
        damage['tires'][tireKey]
          ? [languageTranslator(translateDamageKey(key, tireKey))]
          : []
      )
    } else if (damage[key] && !(key === 'hadOther' || key === 'hadWindow')) {
      return [
        languageTranslator(translateDamageKey(key, damage[key] as string)),
      ]
    }
    return []
  })

  return damageList.join(', ')
}
